<template>
    <section id="tasks-sidebar">
        <h3 class="title">My Tasks</h3>
        <div class="tasks" v-if="status == 'ready'">
            <task-item v-for="(task, index) in tasks"
                :key="index" 
                :task-id="task.taskId"
                :title="task.title"
                :description="task.description"
                :url="task.url"
                :app-id="task.app.id"
                :app-name="task.app.name"
                :image="task.appAvatar"
                :due="task.due"
                :created-at="task.createdAt"
                :disabled=task.viewed
                @taskMarked="onTaskMarked(index, $event)">
            </task-item>
        </div>
        <div class="status-message" v-if="showStatusMessage">
            <p class="loading" v-if="status === 'loading'"><i class="fas fa-circle-notch fa-spin"></i></p>
            <button class="retry" @click="init()" v-if="status === 'error'"><i class="fas fa-sync"></i>Retry</button>
            <p class="not-found" v-if="status === 'ready'">
                <span class="icon"><i class="fas fa-tasks"></i></span>
                <span class="text">No Tasks</span>
            </p>
        </div>
    </section>
</template>

<script>
import TaskItem from "@/components/dashboard/TaskItem";

export default {
    name: "tasks-sidebar",
    components: {
        TaskItem
    },
    data() {
        return {
            status: "ready",
            tasks : []
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.status = "loading";
            try {
                //let response = await TasksService.getUserTasks();
                //this.tasks = response.data;
                this.tasks = [];
                this.status = "ready";
            } catch(e) {
                this.status = "error";
                this.tasks = [];
            }
        },
        onTaskMarked(taskIndex, read) {
            this.tasks[taskIndex].viewed = read;
        }
    },
    computed: {
        noTasksFound() {
            return this.tasks && this.tasks.length == 0;
        },
        showStatusMessage() {
            return this.status != "ready" || (this.status == "ready" && this.noTasksFound);
        }
    },
    watch: {
        tasks: {
            deep: true,
            handler() {
                let numberOfUnreadTasks = this.tasks.filter(task => { return task.viewed === false; } ).length;
                this.$store.commit("setNumberOfUnreadTasks", numberOfUnreadTasks);
            }
        }
    }
}
</script>
